export const languageText ={
    
    firstNavigation: "อัพเดทตลาดหุ้น ",
    firstNavigationEn: "Market news ",
    secondNavigation: " กิจกรรม ",
    secondNavigationEn: " Activities ",
}